import { SourcesBlock, type ChatMessageItem } from '@kanbu/chatbot-ui';
import { SourcesDisplayMode, type SourcesFormat } from '@kanbu/schema/enums';

import { sourceEvidence } from './sourceEvidence';

export function AdminSourceDetails(props: {
  message: ChatMessageItem;
  isVoice: boolean;
  sourcesFormat: SourcesFormat;
}) {
  const { message, isVoice, sourcesFormat } = props;
  const { selected, hasAnswer } = sourceEvidence(message, isVoice);
  if (!hasAnswer || !selected?.length) return null;

  return (
    <SourcesBlock
      sources={selected}
      sourcesFormat={sourcesFormat}
      sourcesDisplayMode={SourcesDisplayMode.Pills}
    />
  );
}
